export abstract class BaseSearchParametersModel {
    public searchTab: string;
    public searchText: string;
    public sortOption: string;
    public pageNumber: number;
    public pageSize: number;
}
